import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCreditCard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCreditCard1"><Path d="M2 4.00293H21.99L21.9922 4.75075C21.9964 6.18525 21.9962 7.61979 21.9961 9.05303L21.9961 19.9961H2V10.5H21.9961V9H2V4.00293Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCreditCard1;
